<template>
  <div>
    <!--기본정보-->
    <field-select-module
      v-model="form.stdInfo"
      :board="board"
      :is-print="isPrint"/>

    <!-- 관리감독자 정보 -->
    <div>
      <vs-row class="mt-6 mb-4">
        <vs-col vs-type="flex" vs-justify="left" vs-align="center" w="12">
          <h5><i class="dot"></i> 관리감독자 차상위자 정보</h5>
        </vs-col>
      </vs-row>

      <div class="writeGridContainer">
        <div>
          <div>구분</div>
          <vs-select
            v-model="form.관리감독자정보.구분"
            autocomplete
            :readonly="board.readonly">
            <vs-select-item v-for="item in ['관리직', '생산직']" :text="item" :value="item"></vs-select-item>
          </vs-select>
        </div>
        <div>
          <div>부서명</div>
          <ml-input v-model="form.관리감독자정보.부서명" :readonly="board.readonly" />
        </div>
        <div>
          <div>직무</div>
          <ml-input v-model="form.관리감독자정보.직무" :readonly="board.readonly" />
        </div>
        <div>
          <div>사번</div>
          <ml-input v-model="form.관리감독자정보.사번" :readonly="board.readonly" />
        </div>
        <div>
          <div>직급</div>
          <ml-input v-model="form.관리감독자정보.직급" :readonly="board.readonly" />
        </div>
        <div>
          <div>이름</div>
          <ml-input v-model="form.관리감독자정보.이름" :readonly="board.readonly" />
        </div>
        <div>
          <div>선임일자</div>
          <date-selector v-model="form.관리감독자정보.선임일자" :readonly="board.readonly"  />
        </div>
      </div>
    </div>

    <!-- 파일첨부 -->
    <file-upload-module :readonly="board.readonly" v-model="form.fileList" :is-print="isPrint" class="mt-8" />
  </div>
</template>

<script>
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import FileUploadModule from "@/views/modules/FileUploadModule.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

export default {
  components: {
    DateSelector,
    FileUploadModule,
    FieldSelectModule,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
  },
  data() {
    return {
      form: {
        stdInfo: {},
        "관리감독자정보": {
          "구분": "",
          "부서명": "",
          "직무": "",
          "사번": "",
          "직급": "",
          "이름": "",
          "선임일자": new Date().format("yyyy-MM-dd"),
        },
        fileList: []
      },
    };
  },
  computed: {
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
</style>
